export default {
    indexTermSignatures:            { method: 'get',    url: 'term_signatures' },
    createTermSignature:            { method: 'post',   url: 'term_signatures' },
    updateTermSignature:            { method: 'put',    url: 'term_signatures/{id}' },
    destroyTermSignature:           { method: 'delete', url: 'term_signatures/{id}' },
    indexTermSignatureStatus:       { method: 'get',    url: 'term_signatures/status' },
    showTermSignature:              { method: 'get',    url: 'term_signatures/{id}/show' },
    showTermSignatureByAccessToken: { method: 'get',    url: 'term_signatures/access/{accessToken}' },
    termSignatureGenerate:          { method: 'post',   url: 'term_signatures/generate' },
    resendTermSignatures:           { method: 'post',   url: 'term_signatures/resend' },
    destroyBatchTermSignatures:     { method: 'post',   url: 'term_signatures/destroy-batch' },
    getTermSignatureNotifications:  { method: 'get',    url: 'term_signatures/{id}/notifications' },
    getPendingBlockingTerms:        { method: 'get',    url: 'teachers/{teacherId}/pending-blocking-terms' },
    showTermSignatureByTeacher:     { method: 'get',    url: 'teachers/term-signatures/{id}' },
    signByTeacherOwner:             { method: 'post',   url: 'teachers/term-signatures/{id}/sign' },
    downloadByTeacherOwner:         { method: 'get',    url: 'teachers/term-signatures/{id}/download' },
}